export const DIAMOND_SHORTAGE_EVENT = 'blockbattle:diamond-shortage';
export const DIAMOND_SHORTAGE_CLOSE_EVENT = 'blockbattle:diamond-shortage-close';

export type DiamondShortageDetail = {
  readonly source?: string;
};

export const isDiamondShortageError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  'code' in error &&
  error.code === 'INSUFFICIENT_DIAMONDS';

export const showDiamondShortage = (detail: DiamondShortageDetail = {}): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<DiamondShortageDetail>(DIAMOND_SHORTAGE_EVENT, { detail }));
};
